import { useEffect } from 'react'
import useUser from './useUser'

const useIntercom = () => {
  const { account, roles } = useUser()

  const userRole = roles?.[0]?.name

  useEffect(() => {
    if (account) {
      globalThis.Intercom?.('boot', {
        app_id: 'zz370yt5',
        api_base: 'https://api-iam.intercom.io',
        email: account.email,
        name: account.fullName,
        user_id: account.id,
        hide_default_launcher: true,
        havelock_role: userRole,
        language_override: account.lang,
      })
    }
  }, [account, userRole])

  useEffect(() => {
    return () => {
      globalThis.Intercom?.('shutdown')
    }
  }, [])
}

export default useIntercom
